var newSliderSmallManager = (function () {

    var carousel = $('.new-slider-small-component .owl-carousel');
    //var cardItems = carousel.find('.card-container').length;
    var animation_duration = $(".new-main-slider-small").data("customanimationsd");
    var animation_interval = $(".new-main-slider-small").data("customanimationsi");
    //console.log('testtt'+animation_duration + '----' + animation_interval);

    function init(){
        $(document).ready( function(){
            if($ ('.new-slider-small-component').length <= 0){
                return;
            }else{
                $ ('.new-slider-small-component .owl-carousel.new-main-slider-small').each(function () {
                    var currentCarousel = $(this);
                    if (currentCarousel.data('custom-init-function')!=undefined){
                        var customFunction = currentCarousel.data('custom-init-function');
                        const functions= {
                            'startLeftTextIconsCarousel': startLeftTextIconsCarousel,
                            'startLeftTextAndImageCarousel':startLeftTextAndImageCarousel,
                            'startGamificationCarousel': startGamificationCarousel,
                            'startLeftTextCarousel': startLeftTextCarousel,
                            'startRightTextCarousel': startRightTextCarousel,
                            'startBgTextImageCarousel': startBgTextImageCarousel
                        };
                        var functionChosen = functions[customFunction];
                        functionChosen();
                    }else{
                        startGamificationCarousel();
                        startLeftTextAndImageCarousel();
                        startLeftTextCarousel();
                        startRightTextCarousel();
                        startBgTextImageCarousel();
                        startLeftTextIconsCarousel();
                    }

                })
            }
        })
    }





    //right text carousel
    function startRightTextCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-right-text").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-right-text").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: true,
                center: true,
                loop: false,
                responsive:{
                    0:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    }
                },
                onInitialized: function (event) {
                    newSliderCarouselManager.makeAccessibilityImprovements($(event.target))
                },
                onTranslated:newSliderCarouselManager.onTranslatedSetDots
            });
        }
    }

    function startLeftTextIconsCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-left-text-icons").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-left-text-icons").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: false,
                center: true,
                loop: false,
                responsive:{
                    0:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: false,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: true,
                        margin: 60
                    }
                },
                onInitialized: function (event) {
                    var target = $(event.target);
                    newSliderCarouselManager.makeAccessibilityImprovements(target)
                    if (target.find('.owl-nav:not(.disabled)').length>0){
                        target.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                        target.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                    }
                },
                onTranslated:newSliderCarouselManager.onTranslatedSetDots
            });
        }
    }

    //right text carousel
    function startBgTextImageCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-bg-text-image").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-bg-text-image").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: false,
                center: true,
                loop: false,
                responsive:{
                    0:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: false,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: true,
                        margin: 60
                    }
                },
                onInitialized: function (event) {
                    var target = $(event.target);
                    newSliderCarouselManager.makeAccessibilityImprovements(target)
                    if (target.find('.owl-nav:not(.disabled)').length>0){
                        target.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                        target.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                    }
                },
                onTranslated:newSliderCarouselManager.onTranslatedSetDots
            });
        }
    }







    //left text carousel
    function startLeftTextCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-left-text").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-left-text").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: true,
                center: true,
                loop: false,
                responsive:{
                    0:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: true,
                        center: false,
                        loop: animation_interval > 1 ? true : false,
                        nav: false,
                        margin: 60
                    }
                },
                onInitialized: function (event) {
                    newSliderCarouselManager.makeAccessibilityImprovements($(event.target))
                },
                onTranslated:newSliderCarouselManager.onTranslatedSetDots
            });
        }
    }

    //left text and image carousel
    function startLeftTextAndImageCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-left-text-and-image").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-left-text-and-image").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: false,
                center: true,
                loop: true,
                responsive:{
                    0:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: true,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: true,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: true,
                        center: false,
                        loop: true,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        autoplayTimeout: animation_interval > 1 ? animation_interval: 4000,
                        autoplayHoverPause: animation_interval > 1 ? true : false,
                        autoplay: animation_interval > 1 ? true : false,
                        smartSpeed: animation_duration > 1 ? animation_duration: 450,
                        mouseDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: false,
                        center: false,
                        loop: true,
                        nav: true,
                        margin: 60
                    }
                },
                onInitialized: function (event) {
                    var target = $(event.target);
                    newSliderCarouselManager.makeAccessibilityImprovements(target)
                    if (target.find('.owl-nav:not(.disabled)').length>0){
                        target.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                        target.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                    }
                },
                onTranslated:newSliderCarouselManager.onTranslatedSetDots
            });
        }
    }

    //gamification carousel
    function startGamificationCarousel(){
        if($(".new-slider-small-component .owl-carousel .new-slider-small-gamification").length){
            $(".new-slider-small-component .owl-carousel .new-slider-small-gamification").closest('.new-slider-small-component .owl-carousel').owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: false,
                center: true,
                loop: false,
                responsive:{
                    0:{
                        mouseDrag: false,
                        touchDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: false,
                        center: false,
                        nav: false,
                        margin: 60
                    },
                    768:{
                        mouseDrag: false,
                        touchDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: true,
                        dots: false,
                        center: false,
                        nav: false,
                        margin: 60
                    },
                    992:{
                        mouseDrag: false,
                        touchDrag: false,
                        items: 1,
                        stagePadding: 0,
                        singleItem: false,
                        dots: false,
                        center: false,
                        nav: false,
                        margin: 60
                    }
                }
            });
        }
    }

    return {init: init}

})(jQuery);